"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormListPage = exports.FormListPageConfig = void 0;
var tslib_1 = require("tslib");
var icons_1 = require("../components/icon/icons");
var table_1 = require("../components/table/table");
var i18n_1 = require("../i18n");
var form_list_1 = require("../modules/form/form.list");
var services_1 = require("../services");
var index_1 = require("../store/index");
var page_1 = require("./page");
exports.FormListPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formList,
    path: '/form/list',
    auth: {
        required: true
    },
    nav: {
        name: i18n_1.T.LIST_FORM_LIST,
        icon: icons_1.MaterialIcon.CONTENT_PASTE
    }
};
var FormListPage = /** @class */ (function (_super) {
    tslib_1.__extends(FormListPage, _super);
    function FormListPage() {
        var _this = _super.call(this, exports.FormListPageConfig) || this;
        _this.component = new form_list_1.FormList();
        index_1.AppStore.FormSummary.refresh();
        return _this;
    }
    Object.defineProperty(FormListPage.prototype, "nodes", {
        get: function () {
            if (services_1.Services.Department.current == null) {
                return null;
            }
            var userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
            if (!services_1.Services.UserProfile.canEditForms(userProfile)) {
                return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_MENU_TITLE_PERMISSION), [], []);
            }
            return this.component.view();
        },
        enumerable: false,
        configurable: true
    });
    return FormListPage;
}(page_1.IkePage));
exports.FormListPage = FormListPage;
//# sourceMappingURL=form.list.page.js.map